import { useNavigate } from "react-router-dom";
import { KanbanSquare, MessagesSquare } from "lucide-react";
import { useChat } from "@/contexts/ChatContext";
import { cn } from "@/lib/utils";

/** Conmutador entre la lista de chats y el tablero de trabajos (mismo sitio en las dos vistas). */
export function ChatTrabajosSwitch({ activo, className = "" }) {
  const navigate = useNavigate();
  const { totalNoLeidos } = useChat();
  const opciones = [
    { key: "chat", label: "Chats", icon: MessagesSquare, to: "/chat", badge: totalNoLeidos },
    { key: "trabajos", label: "Trabajos", icon: KanbanSquare, to: "/trabajos" },
  ];
  return (
    <div className={cn("grid grid-cols-2 rounded-lg bg-muted/70 p-1", className)}>
      {opciones.map(({ key, label, icon: Icon, to, badge }) => (
        <button
          key={key}
          type="button"
          onClick={() => activo !== key && navigate(to)}
          className={cn(
            "flex items-center justify-center gap-1.5 h-8 rounded-md text-xs transition",
            activo === key ? "bg-background shadow-sm font-medium" : "text-muted-foreground hover:text-foreground"
          )}
        >
          <Icon className="w-3.5 h-3.5" />
          {label}
          {badge > 0 && activo !== key && (
            <span className="min-w-[16px] h-4 px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-medium flex items-center justify-center">{badge}</span>
          )}
        </button>
      ))}
    </div>
  );
}
